var _style, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInviteFriendsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 666.7 600",
    style: {
      enableBackground: "new 0 0 666.7 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n\t.st1{fill:#2159D1;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 40,
    className: "st0",
    width: 466,
    height: 481
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6",
    className: "st1",
    d: "M500,0c53.3,0,96.8,41.6,99.8,94.1l0.2,5.9v145l19.8-8.8c20.5-9.1,44.1,5,46.6,26.6l0.2,3.9v266.7 c0,35.1-27.2,63.9-61.7,66.5l-5,0.2H66.7c-35.1,0-63.9-27.2-66.5-61.7l-0.2-5V266.7c0-22.4,22.5-38.2,43.2-31.8l3.6,1.4l19.8,8.8 V100c0-53.3,41.6-96.8,94.1-99.8l5.9-0.2C166.6,0,500,0,500,0z M500,66.7H166.7c-18.4,0-33.3,14.9-33.3,33.3v174.6l200,88.9 l200-88.9V100C533.3,81.6,518.4,66.7,500,66.7z M333.3,166.7c18.4,0,33.3,14.9,33.3,33.3c0,17.1-12.9,31.2-29.4,33.1l-3.9,0.2h-66.7 c-18.4,0-33.3-14.9-33.3-33.3c0-17.1,12.9-31.2,29.4-33.1l3.9-0.2H333.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteFriendsIcon);
export default __webpack_public_path__ + "static/media/invite_friends_icon.c7620051b8344d031707cb0587f06ba6.svg";
export { ForwardRef as ReactComponent };